import { ChangeDetectorRef, Component, ElementRef, HostListener, Input, OnChanges, OnInit, SimpleChanges, ViewChild } from '@angular/core';

import { NDDFormErrorService } from '@shared/ndd-ng-forms/ndd-ng-form-error/shared/ndd-ng-form-error.service';
import { NDDFormsBaseComponent } from '@shared/ndd-ng-forms/shared/ndd-ng-forms.base-component';

import { NDDFormPopupComponent } from '../ndd-ng-form-popup/ndd-ng-form-popup.component';
import { INDDFormDropDownListData } from './shared/ndd-ng-form-dropdownlist.model';

/** Componente dropdownlist. */
@Component({
    selector: 'ndd-ng-form-dropdownlist',
    template: require('./ndd-ng-form-dropdownlist.component.html'),
})
export class NDDFormDropDownListComponent extends NDDFormsBaseComponent implements OnInit, OnChanges {

    private static KEY_CODE_SPACE: number = 32;

    /** Lista de itens. */
    @Input() public controlData: INDDFormDropDownListData[];
    /** Altura máxima da listagem de itens. */
    @Input() public controlListMaxHeight: string = '200px';
    /** Apresenta popup acima do campo */
    @Input() public controlShowPopupOnTop?: boolean = false;

    @ViewChild('ddlInput', { static: false }) public ddlInput: ElementRef;
    @ViewChild(NDDFormPopupComponent, { static: false }) public popupComponent: NDDFormPopupComponent;

    /** Item atual selecionado. */
    public selectedData: INDDFormDropDownListData;

    /** Define exibição da lista. */
    public showPopup: boolean;

    constructor(private elemRef: ElementRef, formErrorService: NDDFormErrorService, cdr: ChangeDetectorRef) {
        super(formErrorService, cdr);
    }

    public ngOnInit(): void {
        super.addControl();
        super.addValidators();
    }

    public ngOnChanges(changes: SimpleChanges): void {
        super.ngOnChanges(changes);
        // Quando troco o valor do controlValue, ele tem que atualizar o selectData
        if (changes.controlValue) {
            this.defineOption();
        }
    }

    /** Verifica cliques fora do componente. */
    @HostListener('document:click', ['$event'])
    public offClick(event: any): void {
        // Caso o clique tenha sido fora do componente, fecha a lista.
        if (this.showPopup
            && !this.elemRef.nativeElement.getElementsByClassName('ndd-ng-form-internal-dropdownlist')[0].contains(event.target)
            && !this.popupComponent.popup.nativeElement.contains(event.target)) {

            this.showPopup = false;
        }
    }

    /**
     * Inicialização da lista.
     *
     * @param {INDDFormDropDownListData} data Item definido como seleção inicial, se houver.
     * @memberof NDDFormDropDownListComponent
     */
    public popupInit(data: INDDFormDropDownListData): void {
        this.selectedData = data;
    }

    /**
     * Exibe/Esconde a lista.
     *
     * @memberof NDDFormDropDownListComponent
     */
    public showList(event: any): void {
        // Navegação por teclado: Tecla Backspace exibe a lista de itens.
        if (event.keyCode && event.keyCode !== NDDFormDropDownListComponent.KEY_CODE_SPACE) { return; }

        event.preventDefault();

        this.ddlInput.nativeElement.focus();

        if (this.showPopup) {
            super.updateValidity();
        }

        this.showPopup = !this.showPopup;
    }

    /**
     * Evento de seleção de item da lista.
     *
     * @param {INDDFormDropDownListData} data Item selecionado.
     * @memberof NDDFormDropDownListComponent
     */
    public popupSelectedValue(data: INDDFormDropDownListData): void {
        if (this.control.value !== data.value) {
            if (!this.control.dirty) {
                this.control.markAsDirty();
            }
            // Define o valor no control e o subscribe já atualiza o selectData
            this.control.setValue(data.value);
        }

        this.showPopup = false;
        this.selectedData = data;
        this.ddlInput.nativeElement.value = data.text;
        this.controlValueChange.emit(data.value);
    }

    /**
     * Define a classe do botão.
     *
     * @returns {string} Classe.
     * @memberof NDDFormDropDownListComponent
     */
    public getButtonClass(): string {
        const baseClass: string = 'ndd-ng-form-dropdownlist__btn';

        if (this.controlDisabled) {
            return `${ baseClass } ndd-ng-form-dropdownlist__btn--disabled`;
        }

        return baseClass;
    }

    /**
     * Metodo que exibe uma opção que está em controlData conforme o valor que está em controlValue.
     *
     * @memberof NDDFormDropDownListComponent
     */
    private defineOption(): void {
        if (!this.controlValue || !this.controlData) {
            this.selectedData = null;

            return;
        }
        for (const data of this.controlData) {
            // Se a opção é igual ao controlValue
            if (data.value === this.controlValue) {
                this.selectedData = data;
                break;
            }
        }
    }
}
